import {dentroJanelaSemanal} from './prazoFechamentoSemanal';

export const dentroPrazoInsumos = dentroJanelaSemanal;

export function podeAlterarInsumo(linha, contexto, agora = new Date()) {
  const { agenda, tipoUsuario } = contexto || {};
  return !!linha && !!agenda && ['A', 'O'].includes(tipoUsuario)
    && Number.isInteger(Number(agenda.id)) && Number(agenda.id) > 0
    && Number(linha.idagenda) === Number(agenda.id)
    && linha.status === 'inicial' && dentroPrazoInsumos(agenda.inicio, agora);
}

export function colunasAcoesInsumos({ obterContexto, onEditar, onApagar, agora = () => new Date() }) {
  const pode = cell => podeAlterarInsumo(cell.getRow().getData(), obterContexto(), agora());
  const coluna = (title, icone, acao) => ({
    title, width: 60, headerSort: false, responsive: 0, hozAlign: 'center',
    formatter: cell => pode(cell) ? `<i class='${icone}'></i>` : '-',
    cellClick: (e, cell) => {
      if (pode(cell)) acao(cell.getRow().getData());
    }
  });
  return [coluna('Editar', 'fas fa-edit', onEditar), coluna('Apagar', 'fa fa-trash-o', onApagar)];
}
